module.exports = __webpack_public_path__ + "static/media/piano-keyboard.a080fa9e.svg";